export default "__VITE_ASSET__hET_8ksL__"